import React, { Component } from "react";
import styles from './styles.css'

import Title from '../../../components/Title'
import FeatureProject from '../../../components/FeatureProject'
import Project from '../../../components/Project'

import oppyfinderFeature from './projects/oppyfinder/feature.png'
import oppyfinderLogo from './projects/oppyfinder/logo.png'
import eddywolffLogo from './projects/eddywolff/logo.png'
import tkpLogo from './projects/tkp/logo.png'
import huxleyLogo from './projects/huxley/logo.png'
import gchubLogo from './projects/gchub/logo.png'
import tbcLogo from './projects/tbc/logo.png'
import bonafideLogo from './projects/bonafide/logo.png'

class Projects extends Component {
  render() {
    return (
      <div>
        <Title direction='left'>Projects</Title>
        <FeatureProject feature={oppyfinderFeature} tags='Ruby, Ruby on Rails, React' logo={oppyfinderLogo} blurb='Op Shop Directory' description='An API used to get a directory listing of all Op shops in Australia. There is a corresponding React Native Application coming soon.' link='https://api.oppyfinder.com'></FeatureProject>
        <div className='project-list'>
          <Project name="Bona Fide Design Co" color='#000000' logo={bonafideLogo} link='https://www.bonafidedesignco.com'></Project>
          <Project name="The GC Hub" color='#6D6E71' logo={gchubLogo} link='https://gchub.com.au'></Project>
          <Project name="Eddy+Wolff" color='#EECCCC' logo={eddywolffLogo} link='https://www.eddyandwolff.com.au'></Project>
          <Project name="The Kindfulness Project" color='#000' logo={tkpLogo} link='https://www.thekindfulnessproject.com'></Project>
          <Project name="Huxley School of Makeup" color='#000' logo={huxleyLogo} link='https://huxleyschoolofmakeup.com'></Project>
          <Project name="The Bikini Collective" color='#ECCACD' logo={tbcLogo} link='https://www.thebikinicollective.com'></Project>
        </div>
      </div>
    )
  }
}

export default Projects



// WEBPACK FOOTER //
// ./src/parts/home/Projects/index.js